import ResetPassword from "./VerifyEmail";
export default ResetPassword;